<template>
  <div class="recharge">
    <div class="step1" v-if="step==1">
      <div class="con bottomline">
        <div class="tit">充值金额</div>
        <div class="inpbox"><span>¥</span><input v-model="money" class="weui-input" type="number" placeholder="请输入您要充值的金额"></div>
      </div>
      <div class="app-btn-area weui-btn-area">
          <div class="weui-btn" @click="nextstep">充值</div>
          <!-- <div class="weui-btn" @click="nextstepp">充值</div> -->
      </div>
    </div>

    <div class="step2 bottomline" v-if="step==2">
      <div class="tit">充值成功</div>
      <div class="num">￥<span>{{money}}</span></div>
      <div class="app-btn-area weui-btn-area">
          <router-link :to="{ name: 'home' }" class="weui-btn">返回</router-link>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      step:1,
      money:''
    }
  },
  methods:{
    nextstep(){
      let vm = this;
      vm.money = vm.money*1;
      if(!(vm.money>0)){
        vm.publics.message.danger('请输入金额');
        return false;
      }
      vm.order({"money":vm.money})
    },
    // nextstepp(){
    //   let vm = this;
    //   vm.money = vm.money*1;
    //   if(!(vm.money>0)){
    //     vm.publics.message.danger('请输入金额');
    //     return false;
    //   }
    //   order({"money":vm.money})
    // },
    order(data) {
      let vm = this;
            var data = JSON.stringify(data);
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;

            xhr.addEventListener("readystatechange", function() {
                if (this.readyState === this.DONE) {
                    console.log(this.responseText);

                    /* var req = JSON.parse(this.responseText); */
                    let response = JSON.parse(this.response);

                    if (response.code != 1000) {
                        alert(response.error)
                    } else {

                        // ----- pay weixin ---
                        var req = response.data;
                        console.log(req);

                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                            }
                        } else {
                            WeixinJSBridge.invoke(
                                'getBrandWCPayRequest', req,
                                function(res) {
                                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                                        // 使用以上方式判断前端返回,微信团队郑重提示：
                                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                                            // alert("ok")
                                            vm.step = 2;
                                        } else {
                                            // alert("error")
                                                //支付失败/或取消支付跳转页面
                                        }
                                    }
                                });
                        }

                        // -- pay end --
                    }


                }

            });

            xhr.open("POST", vm.publics.API_URL+"account/money/push");
            xhr.setRequestHeader("content-type", "application/json");

            xhr.send(data);

        }
  }
}
</script>



// WEBPACK FOOTER //
// src/recharge.vue